import React from 'react';
import PropTypes from 'prop-types';

// Multibrand-UI Components
import Text from '@zg-rentals/multibrand-ui/lib/Text';

import SpinnerContainer from 'app/shared/components/SpinnerContainer';

// styles
import './style.scss';

const noop = () => {};

const propTypes = {
    propertyList: PropTypes.array,
    onLoadProperties: PropTypes.func,
};

const defaultProps = {
    propertyList: [],
    onLoadProperties: noop,
};

const ConsolidatedPropertyListModal = ({
    propertyList,
    onLoadProperties,
}) => {
    const [isLoading, setIsLoading] = React.useState(false);
    const [propertyNames, setPropertyNames] = React.useState(propertyList);

    React.useEffect(() => {
        if (propertyNames.length === 0 && onLoadProperties !== noop) {
            setIsLoading(true);
            onLoadProperties().then((newPropertyList) => {
                setIsLoading(false);
                setPropertyNames(newPropertyList);
            });
        }
    }, [onLoadProperties, propertyNames.length]);

    return (
        <div className="ConsolidatedPropertyListModal">
            {isLoading
                ? <SpinnerContainer />
                : propertyNames.map((name, i) => <Text key={i} type="h4">{name}</Text>)
            }
        </div>
    );
};

ConsolidatedPropertyListModal.propTypes = propTypes;
ConsolidatedPropertyListModal.defaultProps = defaultProps;

export default ConsolidatedPropertyListModal;
